import * as React from 'react';
import de_DE from 'antd/lib/locale-provider/de_DE';
import en_GB from 'antd/lib/locale-provider/en_GB';
import en_US from 'antd/lib/locale-provider/en_US';
import es_ES from 'antd/lib/locale-provider/es_ES';
import fr_FR from 'antd/lib/locale-provider/fr_FR';
import it_IT from 'antd/lib/locale-provider/it_IT';
import ja_JP from 'antd/lib/locale-provider/ja_JP';
import ko_KR from 'antd/lib/locale-provider/ko_KR';
import pt_BR from 'antd/lib/locale-provider/pt_BR';
import pt_PT from 'antd/lib/locale-provider/pt_PT';
import ru_RU from 'antd/lib/locale-provider/ru_RU';
import sv_SE from 'antd/lib/locale-provider/sv_SE';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import zh_TW from 'antd/lib/locale-provider/zh_TW';
import { Locale } from 'antd/lib/locale-provider';
import { getEnvironment } from '@unifocus/js-utils';

export const getAntdLocale = (): Locale => {
   const locale = getEnvironment().locale;

   if (locale === 'en-US') {
      return en_US;
   }

   if (locale === 'es-ES') {
      return es_ES;
   }

   if (locale === 'de-DE') {
      return de_DE;
   }

   if (locale === 'en-GB') {
      return en_GB;
   }

   if (locale === 'fr-FR') {
      return fr_FR;
   }

   if (locale === 'it-IT') {
      return it_IT;
   }

   if (locale === 'ja-JP') {
      return ja_JP;
   }

   if (locale === 'ko-KR') {
      return ko_KR;
   }

   if (locale === 'pt-BR') {
      return pt_BR;
   }

   if (locale === 'pt-PT') {
      return pt_PT;
   }

   if (locale === 'ru-RU') {
      return ru_RU;
   }

   if (locale === 'sv-SE') {
      return sv_SE;
   }

   if (locale === 'zh-CN') {
      return zh_CN;
   }

   if (locale === 'zh-TW') {
      return zh_TW;
   }

   return en_US;
};
